import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// components
import UsersTable from "components/Tables/UsersTable.js";
// texts as props
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "actions/users";

export const Users = () => {
  const location = useLocation();
  const globalUsers = useSelector((state) => state.users.users);
  const [users, setUsers] = useState(globalUsers);
  const dispatch = useDispatch();

  useEffect(() => {
    setUsers(globalUsers);
  }, [globalUsers]);

  useEffect(() => {
    if (users.length === 0) {
      dispatch(getUsers());
    }

  }, [users, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);


  return (
    <div>
      <UsersTable users={users} onUpdated={(newUsers) => {
        setUsers(newUsers);
      }} />
    </div>
  );
};

export default Users;
